import { useEffect } from 'react';
import { createFileRoute, useRouter, useNavigate, redirect } from '@tanstack/react-router';
import { http } from '@frontend/fetch';
import { useAlert } from '@frontend/design-system';
import Loader from '../../../components/Loader/Loader';
import { useIntegrationsDashboardShallowStore } from '../../../store';
import { checkIsUserAuthenticated } from '../../../utils/helpers';

const SignInCallback = () => {
  const auth = Route.useRouteContext({ select: (ctx) => ctx.auth });
  const params = Route.useParams();
  const alert = useAlert();
  const router = useRouter();
  const navigate = useNavigate();
  const { isUserAuthenticated, setIsUserAuthenticated } = useIntegrationsDashboardShallowStore(
    'isUserAuthenticated',
    'setIsUserAuthenticated'
  );

  useEffect(() => {
    if (params && !isUserAuthenticated) {
      auth
        .handleCallback()
        .then((tokens) => {
          if (tokens) {
            setIsUserAuthenticated(true);
            http.setLocationIdHeader('weave');
          }
        })
        .catch((e) => {
          console.error(e);
          alert.error({
            message: 'There was an error during authentication. Please try again.',
            autoDismissAfter: 2000,
          });
        });
    } else {
      const redirectUrl = sessionStorage.getItem('redirect');
      setIsUserAuthenticated(true);
      if (redirectUrl) {
        sessionStorage.removeItem('redirect');
        navigate({ to: redirectUrl });
      } else {
        navigate({ to: '/dashboard' });
      }
    }
  }, [isUserAuthenticated, auth, params, router.history]);

  return <Loader />;
};

type RedirectReturnType = ReturnType<typeof redirect>;
export const Route = createFileRoute('/_public/sign-in_/callback')({
  component: SignInCallback,
  beforeLoad: (): boolean | RedirectReturnType => {
    if (checkIsUserAuthenticated()) {
      return redirect({
        to: '/dashboard',
      });
    }
    return false;
  },
});
